import SectionHeading from '@/pages/home/components/SectionHeading';
import { statItems, trendBars } from '@/mocks/homeData';

export default function StatsPanel() {
  return (
    <section id="stats" className="scroll-mt-20 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="03"
          eyebrow="Data Board"
          title="深扒数据面板"
          desc="线索、证据、资金、节点四类指标持续更新，近 7 日新增曲线可以直观看到事件热度的变化节奏。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.5fr_1fr] lg:gap-8">
          <dl className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4">
            {statItems.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100/50 p-4"
              >
                <dt className="font-label text-xs text-foreground-500">{stat.label}</dt>
                <dd className="mt-2 flex items-baseline gap-1">
                  <span className="font-heading text-2xl font-black text-foreground-950 md:text-[28px]">
                    {stat.value}
                  </span>
                  <span className="font-label text-[11px] text-foreground-500">{stat.unit}</span>
                </dd>
                <span className="mt-2 font-label text-[11px] text-foreground-500">{stat.note}</span>
              </div>
            ))}
          </dl>

          <div className="flex flex-col rounded-lg border border-background-200 bg-background-100/50 p-5">
            <div className="flex items-center justify-between">
              <span className="font-heading text-sm font-bold text-foreground-950">近 7 日新增线索</span>
              <span className="flex items-center gap-1 font-label text-[11px] text-accent-600">
                <i className="ri-arrow-up-line text-sm leading-none"></i>
                环比 +24%
              </span>
            </div>

            <div className="mt-6 flex h-40 items-end gap-2 md:gap-3">
              {trendBars.map((bar, index) => (
                <div key={bar.label} className="flex flex-1 flex-col items-center gap-2">
                  <div className="flex h-32 w-full items-end">
                    <div
                      className={`w-full rounded-t ${
                        index === trendBars.length - 1 ? 'bg-accent-500' : 'bg-primary-400/80'
                      }`}
                      style={{ height: `${bar.value}%` }}
                    ></div>
                  </div>
                  <span className="font-label text-[10px] text-foreground-500">{bar.label}</span>
                </div>
              ))}
            </div>

            <p className="mt-5 border-t border-background-200 pt-4 text-[13px] leading-6 text-foreground-600">
              新增线索在 09/07 至 09/08 出现明显抬升，主要来自资金往来与合同文件的补充材料。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}